import React, { useEffect } from 'react'
import { createPortal } from 'react-dom'
import { motion, AnimatePresence } from 'framer-motion'
import { cx } from '../lib/cx'
import { Button } from './Button'

export function BottomSheet(props: {
  open: boolean
  title: string
  onClose: () => void
  children: React.ReactNode
}) {
  const { open, title, onClose, children } = props

  useEffect(() => {
    if (!open) return
    const prev = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = prev
    }
  }, [open])

  useEffect(() => {
    if (!open) return
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose()
    }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [open, onClose])

  return createPortal(
    <AnimatePresence>
      {open && (
        <div className="fixed inset-0 z-50 flex items-end justify-center">
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="absolute inset-0 bg-[rgba(2,6,23,0.45)]"
            onClick={onClose}
          />
          <motion.div
            initial={{ y: '100%' }}
            animate={{ y: 0 }}
            exit={{ y: '100%' }}
            transition={{ type: 'spring', damping: 25, stiffness: 300 }}
            className={cx(
              'relative w-full max-w-[500px] rounded-t-[24px] bg-card shadow-sheet border border-line',
              'pb-[max(env(safe-area-inset-bottom),16px)]',
            )}
          >
            <div className="flex items-center justify-between px-5 pt-5">
              <div className="text-[17px] font-extrabold tracking-[-0.02em]">{title}</div>
              <Button variant="ghost" size="sm" onClick={onClose} aria-label="닫기">
                닫기
              </Button>
            </div>
            <div className="px-5 pb-5 pt-3 max-h-[70vh] overflow-auto">{children}</div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>,
    document.body,
  )
}
